
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { BrandingProvider } from "@/contexts/BrandingContext";
import { XeroProvider } from "@/contexts/XeroContext";
import { Toaster } from "@/components/ui/toaster";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Index from "@/pages/Index";
import NotFound from "@/pages/NotFound";
import XeroCallback from "@/pages/XeroCallback";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

import "@/App.css";

export default function App() {
  console.log('App component rendering');
  
  return (
    <BrandingProvider>
      <AuthProvider>
        <XeroProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/xero-callback" element={<XeroCallback />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <Index />
                </ProtectedRoute>
              }
            />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" />} />
          </Routes>
        </Router>
        <Toaster />
      </XeroProvider>
      </AuthProvider>
    </BrandingProvider>
  );
}
